import { createSlice } from '@reduxjs/toolkit'
import { FirestoreDatabase } from '../index'
import { Collection } from 'constants/index'
import { caseInsensitiveSort } from 'utils'
import { signOut } from 'store/auth'
import { first } from 'lodash'

export const initialState = {
  error: null,
  inProgress: false,
  attendees: [],
  confFilter: '',
  currentPage: 0,
  pageSize: 10,
  attendee: null
}

const attendeeSlice = createSlice({
  name: 'attendee',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setConferenceFilter: (state, action) => {
      state.confFilter = action.payload
    },
    setAttendees: (state, action) => {
      state.attendees = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    },
    setAttendee: (state, action) => {
      state.attendee = action.payload
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.attendees = []
      state.confFilter = ''
      state.currentPage = 0
      state.pageSize = 10
      state.attendee = null
    }
  }
})

export const fetchAttendees = (conferenceId) => async (dispatch) => {
  try {
    dispatch(attendeeSlice.actions.setProgress(true))
    const isDataFetched = false
    const unsubscribe = await FirestoreDatabase.collection(Collection.ATTENDEES)
      .where('conferenceId', '==', conferenceId)
      .onSnapshot((documents) => {
        const attendees = []
        documents.forEach((doc) => {
          attendees.push({
            id: doc.id,
            ...doc.data()
          })
        })
        dispatch(attendeeSlice.actions.setAttendees(caseInsensitiveSort(attendees, 'fullName')))
        if (!isDataFetched) dispatch(attendeeSlice.actions.setProgress(false))
      })
    return () => unsubscribe()
  } catch (err) {
    dispatch(attendeeSlice.actions.setError(err))
  }
}

export const updateAttendee = (attendeeId, data, onSuccess, onError) => async (dispatch) => {
  try {
    dispatch(attendeeSlice.actions.setProgress(true))
    await FirestoreDatabase.collection(Collection.ATTENDEES).doc(attendeeId).update(data)
    const attendeeDeviceSnap = await FirestoreDatabase.collection(Collection.ATTENDEE_DEVICE)
      .where('attendeeId', '==', attendeeId)
      .get()

    if (!attendeeDeviceSnap?.empty) {
      const attendeeDevice = first(attendeeDeviceSnap.docs)
      const device = { id: attendeeDevice?.id, ...attendeeDevice.data() }
      await FirestoreDatabase.collection(Collection.ATTENDEE_DEVICE).doc(device?.id).update({
        attendeeRole: data?.role
      })
    }
    dispatch(attendeeSlice.actions.setProgress(false))
    onSuccess && onSuccess()
  } catch (err) {
    console.error(err)
    dispatch(attendeeSlice.actions.setProgress(false))
    onError && onError()
  }
}

export const fetchAttendeeById = (attendeeId) => async (dispatch) => {
  try {
    dispatch(attendeeSlice.actions.setProgress(true))
    const snapshot = await FirestoreDatabase.collection(Collection.ATTENDEES).doc(attendeeId).get()
    dispatch(
      attendeeSlice.actions.setAttendee({
        id: snapshot.id,
        ...snapshot.data()
      })
    )
    dispatch(attendeeSlice.actions.setProgress(false))
  } catch (err) {
    dispatch(attendeeSlice.actions.setError(err))
    dispatch(attendeeSlice.actions.setProgress(false))
  }
}

export default attendeeSlice
